// Footer-section editor (PRINT_TEMPLATE_PLAN.md §4.4).
//
// Three fields: show toggle, multi-line text template (variable
// palette wired), show_page_numbers toggle. The text template
// preserves \n inside the rendered footer.

import { VariablePalette } from './VariablePalette';
import { getVariablesForType } from '../variables';
import type { FooterConfig, PrintTemplateType } from '../../../../types/api';
import styles from './FooterEditor.module.css';

export interface FooterEditorProps {
  value: FooterConfig;
  onChange: (next: FooterConfig) => void;
  templateType: PrintTemplateType;
}

export function FooterEditor({
  value,
  onChange,
  templateType,
}: FooterEditorProps): JSX.Element {
  function update<K extends keyof FooterConfig>(key: K, v: FooterConfig[K]) {
    onChange({ ...value, [key]: v });
  }

  return (
    <section className={styles.section} aria-label="Footer configuration">
      <header className={styles.head}>
        <h3 className={styles.title}>Footer</h3>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={value.show}
            onChange={(e) => update('show', e.target.checked)}
          />
          <span>Show footer</span>
        </label>
      </header>

      {value.show ? (
        <div className={styles.body}>
          <VariablePalette
            label="Footer text"
            value={value.text_template}
            onChange={(next) => update('text_template', next)}
            variables={getVariablesForType(templateType)}
            rows={3}
            maxLength={2000}
            placeholder="Generated {{generated_at}} by {{generated_by}}"
          />
          <label className={styles.toggle}>
            <input
              type="checkbox"
              checked={value.show_page_numbers}
              onChange={(e) => update('show_page_numbers', e.target.checked)}
            />
            <span>Show page numbers (Page N of M, bottom-right)</span>
          </label>
        </div>
      ) : null}
    </section>
  );
}
